import React, {Component} from 'react';
import {Button, Container, Form, Grid, Header, Icon, Input, Segment, Tab} from "semantic-ui-react";
import {connect} from "react-redux";
import * as InteractiveMapActions from "../actions/InteractiveMapActions";
import moment from "moment";
import DateLegend from "../components/interactive-map/dateLegend";

class SearchBar extends Component {

    state = {
        from: null,
        fromString: "",
        to: null,
        toString: "",
        date: null,
        dateString: "",
        price: "",
        priceString: "",
        newSearch: false,
    };

    setInputElement(part, el) {

        console.log("SB: setInputElement");

        if (this.inputs && this.inputs.from && this.inputs.to) return;
        if (!this.inputs) this.inputs = {};
        this.inputs[part] = el;

        if (this.inputs.from && this.inputs.to) {
            this.initAutocomplete();
        }

    }

    handleChange(e) {
        let updates = {[e.target.name]: e.target.value};
        if (e.target.name === "dateString") {
            updates["date"] = moment(e.target.value, "DD/MM/YYYYY");
        }
        this.setState(updates);
    }

    componentWillReceiveProps(nextProps, nextContext) {

        this.initAutocomplete();

    }

    initAutocomplete() {

        console.log("SB: INIT Autocomplete", this.inputs);

        if (!window.google || !this.inputs || !this.inputs["from"] || !this.inputs["to"]) {
            console.log("SB: not ready yet");
            setTimeout(this.initAutocomplete.bind(this), 500);
            return;
        }

        let _this = this;
        let autocomplete = new window.google.maps.places.Autocomplete(this.inputs["from"]);
        autocomplete.addListener('place_changed', function () {
            console.log("SB: place_changed");
            let place = autocomplete.getPlace();
            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                console.error("No details available for input: '" + place.name + "'");
                return;
            }
            _this.setState({from: place, fromString: place.formatted_address});
        });
        let autocomplete2 = new window.google.maps.places.Autocomplete(this.inputs["to"]);
        autocomplete2.addListener('place_changed', function () {
            let place = autocomplete2.getPlace();
            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                console.error("No details available for input: '" + place.name + "'");
                return;
            }
            _this.setState({to: place, toString: place.formatted_address});
        });


    }

    submit() {

        const {from, to, date} = this.state;

        let radius = 100000; // [m]
        let dateRange = 7; // [days]

        this.props.search({
            from, to, date, radius, dateRange
        })

    }

    addRequest() {
        const {from, to, date, price} = this.state;

        this.props.addRequest({
            from, to, date, price, //dateRange
        });
    }

    render() {
        const {from, fromString, to, toString, date, dateString, price, priceString, newSearch} = this.state;
        const {fetched, searching, searchComplete, searchFilterIds, cancelSearch} = this.props;

        let requestable = from && to;

        let panes = [
            {
                // menuItem: { key: 'search', icon: 'search', content: 'search' }, render: () =>
            },
            {menuItem: { key: 'departure', icon: 'calendar', content: 'departure' }, render: () => <DateLegend/>},
        ];


        return <div className="tab-container">
            <Segment raised>
                {(searchComplete && !newSearch) ? <div>

                        <Form onSubmit={() => this.submit()}>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column>
                                        <Button icon="arrow left" size="small" basic onClick={cancelSearch} />
                                        <em>{searchFilterIds.length} results found{fromString && (" from " + fromString)}{toString && (" to " + toString)}{dateString && (" at " + dateString)}. {requestable && "To identify demand you can request a voyage below:"}</em>
                                    </Grid.Column>
                                </Grid.Row>
                                {requestable &&
                                <Grid.Row>
                                    <Grid.Column width={5}>
                                        <Form.Field>
                                            <label>
                                                Price
                                            </label>
                                            <input placeholder="Price" ref={el => this.setInputElement("price", el)}
                                                   name="price" value={price}
                                                   onChange={(e) => this.handleChange(e)}/>
                                        </Form.Field>
                                        What would you pay for this voyage?
                                    </Grid.Column>
                                    <Grid.Column width={1} style={{paddingTop: "23px"}}>
                                        <Button color="blue" disabled={!fetched || (!fromString && !toString && !date)}
                                                onClick={() => this.addRequest()}
                                                loading={searching}>Submit</Button>
                                    </Grid.Column>
                                </Grid.Row>
                                }
                            </Grid>
                        </Form>
                    </div>
                    :
                    <Form onSubmit={() => this.submit()}>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={5}>
                                    <Form.Field>
                                        <label>
                                            From
                                            {from && <Icon name="remove" style={{float: "right"}}
                                                           onClick={(e) => this.setState({
                                                               from: null,
                                                               fromString: ""
                                                           })}/>}
                                        </label>
                                        <input placeholder="From" ref={el => this.setInputElement("from", el)}
                                               name="fromString" value={fromString}
                                               onChange={(e) => this.handleChange(e)}/>
                                    </Form.Field>
                                    Radius: 100 km
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <Form.Field>
                                        <label>
                                            To
                                            {to && <Icon name="remove" style={{float: "right"}}
                                                         onClick={(e) => this.setState({to: null, toString: ""})}/>}
                                        </label>
                                        <input placeholder="To" ref={el => this.setInputElement("to", el)}
                                               name="toString" value={toString}
                                               onChange={(e) => this.handleChange(e)}/>
                                    </Form.Field>
                                    Radius: 100 km
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    <Form.Field>
                                        <label>
                                            Departure (dd/mm/yyyy)
                                            {dateString && <Icon name="remove" style={{float: "right"}}
                                                                 onClick={(e) => this.setState({dateString: ""})}/>}
                                        </label>
                                        <input placeholder="Date" name="dateString" value={dateString}
                                               onChange={(e) => this.handleChange(e)}/>
                                    </Form.Field>
                                    {dateString && ((date && date.isValid) ? "Valid date: " + date.format("D MMMM YYYY") : "Invalid date")}
                                </Grid.Column>
                                <Grid.Column width={1} style={{paddingTop: "23px"}}>
                                    <Button color="blue" disabled={!fetched || (!fromString && !toString && !date)}
                                            loading={searching}>Search</Button>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                    <em>Enter your desired departure location, arrival location, or both.</em>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                }
            </Segment>
            {/*<Tab menu={{secondary: true, pointing: true, color: "white", inverted: true}} panes={panes}/>*/}
        </div>;
    }
}


export default connect(state => ({
    fetched: state.interactiveMap.fetchedRoutes,
    searching: state.interactiveMap.searching,
    searchComplete: state.interactiveMap.searchComplete,
    searchFilterIds: state.interactiveMap.searchFilterIds,
}), dispatch => ({
    search: (params) => dispatch(InteractiveMapActions.search(params)),
    addRequest: (params) => dispatch(InteractiveMapActions.addRequest(params)),
    cancelSearch: () => dispatch(InteractiveMapActions.cancelSearch()),
}))(SearchBar)


// WEBPACK FOOTER //
// ./src/components/SearchBar.js